import get from 'lodash/get';
import { useTheme } from '@mui/material/styles';

import vkontakteIcons from './icons';
import type { IconComponentProps, IconsMapType } from './Icon.types';

export const Icon = ({ name, size, color, ...props }: IconComponentProps) => {
  const theme = useTheme();

  const colorCode = color ? get(theme.tokens.colors, color) : undefined;
  const sizeInPixels = theme.tokens.iconSizes[size];

  const iconVariants = vkontakteIcons[name];
  const ExactIcon = (iconVariants as IconsMapType)[sizeInPixels];

  if (ExactIcon) {
    return (
      <ExactIcon
        {...props}
        width={sizeInPixels}
        height={sizeInPixels}
        color={colorCode}
      />
    );
  }

  // Find the closest available icon size
  const sizes = Object.keys(iconVariants).map(Number);
  const closestSize = sizes.reduce((prev, curr) =>
    Math.abs(curr - sizeInPixels) < Math.abs(prev - sizeInPixels) ? curr : prev,
  );

  const ClosestIcon = (iconVariants as IconsMapType)[closestSize];
  return (
    <ClosestIcon
      {...props}
      width={sizeInPixels}
      height={sizeInPixels}
      color={colorCode}
    />
  );
};
